module.exports = __webpack_public_path__ + "static/media/PG-Character-Berry-Donut.fd61ddbe.png";